module.exports = __webpack_public_path__ + "img/twitter-brands.0e125246.svg";